import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=8084f012&scoped=true"
import script from "./Update.vue?vue&type=script&lang=ts"
export * from "./Update.vue?vue&type=script&lang=ts"
import style0 from "./Update.vue?vue&type=style&index=0&id=8084f012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8084f012",
  null
  
)

export default component.exports